import { render, staticRenderFns } from "./myProjects.vue?vue&type=template&id=5adf225c"
import script from "./myProjects.vue?vue&type=script&lang=js"
export * from "./myProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports